"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.NotificationBadge = void 0;

var _pragma = require("../../../pragma");

var React = _interopRequireWildcard(require("react"));

var _ = require("../..");

var css = _interopRequireWildcard(require("./NotificationBadge.style"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * The NotificationBadge generates a small badge to the top-right of its
 * child(ren).
 *
 * It contains a variant for showing an explicit count value, or just displaying
 * as a small dot to indicate the general presence of notifications.
 *
 * All HTML attributes are supported, and all unhandled props, including refs,
 * are forwarded to the root `Text` component.
 */
const NotificationBadge = /*#__PURE__*/React.forwardRef(({
  children,
  count = 0,
  variant = 'primary',
  ...otherProps
}, ref) => (0, _pragma.createFelaElement)(_.View, _extends({
  css: css.container
}, otherProps), children, count > 0 ? (0, _pragma.createFelaElement)(_.View, {
  alignItems: "center",
  as: _.Text,
  children: variant === 'primary' ? count : undefined,
  color: "text.3",
  css: css.badge,
  cssProps: {
    variant
  },
  justifyContent: "center",
  ref: ref
}) : null));
exports.NotificationBadge = NotificationBadge;
NotificationBadge.displayName = 'NotificationBadge';
var _default = NotificationBadge;
exports.default = _default;
//# sourceMappingURL=NotificationBadge.js.map